import React from 'react'
import client from "../../../services/Api";
import { Modal, ModalManager, Effect } from 'react-dynamic-modal';
import { GrClose } from 'react-icons/gr';
import swal from 'sweetalert';
import FirmwareForm from '../FirmwareForm';

import './index.css'

export default function FirmwareModal({ firmwares, notes, onSave }) {

  const body = document.getElementsByTagName('body')[0];

  const style = {
    overlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: 99999999,
      overflowX: 'hidden',
      overflowY: 'auto',
      perspective: 1300,
      backgroundColor: 'rgba(0, 0, 0, 0.3)',
    },

    content: {
      position: 'relative',
      margin: '15% auto',
      width: 'inherit',
      border: '1px solid rgba(0, 0, 0, .2)',
      background: 'rgb(255, 255, 255)',
      overflow: 'auto',
      borderRadius: '4px',
      outline: 'none',
      boxShadow: '0 5px 10px rgba(0, 0, 0, .3)',
      transition: 'all 0.3s ease-in 0s',
      transformStyle: 'preserve-3d',
      transform: 'translateZ(0px) rotateX(0deg)',
      opacity: '1',
    }

  }

  const closeModal = () => {
    ModalManager.close()
    body.style.overflow = 'auto'
  }

  const handleSave = async (beacon) => {
    ModalManager.close()
    body.style.overflow = 'auto'
    saveFirmware(beacon);
  }

  async function saveFirmware(data) {
    const formData = new FormData()
    formData.append("version", data.version);
    formData.append("notes", data.notes);
    formData.append("file", data.file[0]);
    try {
      await client.post('/api/firmwares', formData)
      await swal("Nova versão do Firmware salva com sucesso!", {
        title: "Sucesso!",
        icon: "success",
      })

      if (onSave)
        onSave();
    } catch (e) {
      const message = e.response != null ? e.response.data.error : e.message;
      console.log(message);
      swal("Erro!", message, "error")
      return null;
    }
  }
  return (
    <div className="FirmwareModal">
      <Modal
        style={style}
        onRequestClose={() => { }}
        effect={Effect.Fall}>
        <div className="header">
          <div className="title">
            Adicionar nova versão
          </div>
          <div className="actions">
            <GrClose onClick={closeModal} />
          </div>
        </div>
        <div className="body">
          <FirmwareForm
            saveFirmware={handleSave}
            onClose={closeModal}
            firmwares={firmwares}
            notes={notes} />
        </div>
      </Modal>
    </div>
  )
}
